// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yiCeSRoDmZFZL3VWziwV{border:1px solid rgba(27,38,70,.2);border-radius:5px;background:#fff;overflow:hidden}.qtVbZOPo8_LfiMThaGM8{box-shadow:0px 3px 6px rgba(0,0,0,.1607843137)}`, "",{"version":3,"sources":["webpack://./src/components/cards/base/Card/styles.module.sass"],"names":[],"mappings":"AACA,sBACE,kCAAA,CACA,iBAAA,CACA,eAAA,CACA,eAAA,CACF,sBACE,8CAAA","sourcesContent":["\n.card\n  border: 1px solid rgba(27, 38, 70, 0.2)\n  border-radius: 5px\n  background: #fff\n  overflow: hidden\n.hasShadow\n  box-shadow: 0px 3px 6px #00000029\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `yiCeSRoDmZFZL3VWziwV`,
	"hasShadow": `qtVbZOPo8_LfiMThaGM8`
};
export default ___CSS_LOADER_EXPORT___;
